import { render } from "./headerHome.vue?vue&type=template&id=f8c07634&scoped=true"
import script from "./headerHome.vue?vue&type=script&lang=js"
export * from "./headerHome.vue?vue&type=script&lang=js"

import "./headerHome.vue?vue&type=style&index=0&id=f8c07634&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c07634"]])

export default __exports__